function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg8",
    viewBox: "0 0 65.087502 19.049999",
    height: "19.049999mm",
    width: "65.087502mm",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer3",
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.1616531
    },
    d: "m 4.8812186,0.49684137 c 0.015638,0.40361492 0.00286,0.80855523 0.00744,1.21261823 C 4.547516,1.900348 4.2063867,2.0911288 3.8652479,2.2820173 3.6601981,2.072012 3.4553656,1.8618144 3.2503158,1.6518101 3.1773827,1.5827959 2.86421,1.2478587 2.9763557,1.3714444 2.5935013,1.7542988 2.210646,2.1371532 1.8277925,2.5200076 1.6921201,2.5945521 1.5662384,2.914079 1.4232583,2.8072709 1.7555287,3.1131122 2.0710404,3.4369965 2.3969004,3.7498718 2.2869248,4.0935383 2.1772373,4.4374957 2.0672617,4.7811633 c -0.3267706,-0.00191 -0.6537709,-0.004 -0.9805405,-0.00591 -0.10038627,0.00353 -0.55842302,-0.00999 -0.39172387,-0.00248 v 1.6240509 c -0.0432316,0.148638 0.093357,0.4637215 -0.083269,0.4892848 C 1.0760353,6.875162 1.5414312,6.898904 2.0061653,6.901383 2.1667135,7.2147276 2.3275114,7.5281759 2.4880596,7.8415194 2.2490576,8.0681554 2.0101347,8.2948573 1.7711318,8.5214924 1.7005062,8.5927664 1.3619494,8.902356 1.4863314,8.7910179 1.9828981,9.2876065 2.4797909,9.7844594 2.9763585,10.281046 3.3232641,9.9573659 3.6701068,9.6335481 4.0170124,9.3098669 c 0.2930958,0.1908712 0.5859429,0.3816854 0.8790378,0.5725569 -0.00191,0.2660842 -0.00352,0.5321442 -0.00543,0.7982292 0.00352,0.100389 -0.010679,0.558425 -0.00296,0.391723 h 1.6245439 c 0.1486447,0.04322 0.4637025,-0.09335 0.4892849,0.08327 C 6.984382,10.731837 6.9931954,10.306674 6.9862127,9.8824209 7.3197664,9.6915094 7.6534032,9.5007753 7.986955,9.309864 L 8.6368723,9.9962428 C 8.708051,10.066954 9.0176767,10.405469 8.9063978,10.281043 9.2892522,9.8981908 9.6721053,9.5153334 10.054959,9.1324799 10.190631,9.0579449 10.316028,8.7378946 10.459001,8.8447227 10.122964,8.5223734 9.8117773,8.1740758 9.48536,7.8415165 9.6250649,7.5282331 9.7649713,7.2146637 9.9046763,6.9013805 c 0.4552367,-0.00267 0.9110467,-0.026069 1.3658587,-0.015275 0.0035,-0.7027768 0.0046,-1.4056244 0.0039,-2.108408 -0.427959,-0.011128 -0.895045,0.00467 -1.3377727,0.00343 L 9.4173299,3.7527943 10.106172,3.1250509 C 10.178933,3.0560844 10.521332,2.750758 10.395899,2.8609462 9.9172823,2.3432757 9.4386901,1.8255194 8.9600731,1.3078479 8.6542814,1.6399324 8.3298421,1.955364 8.0169802,2.280998 7.6733117,2.0903422 7.3298482,1.8995901 6.9861807,1.7089342 6.9930459,1.3048845 6.9845598,0.90041434 7.0014558,0.49680799 Z M 5.9430601,4.0139765 A 1.2991415,1.2991415 0 0 1 7.2424,5.3133164 1.2991415,1.2991415 0 0 1 6.7274927,6.3460868 l 0.03794,1.2411965 H 5.1211788 l 0.049277,-1.2303571 -0.011327,-0.011823 v 0.00153 A 1.2991415,1.2991415 0 0 1 4.6442132,5.3133164 1.2991415,1.2991415 0 0 1 5.9430601,4.0139765 Z",
    id: "path1839"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: "8.01123238px",
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.20028082
    },
    x: 1.4401721,
    y: 18.287943,
    id: "text833"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan831",
    x: 1.4401721,
    y: 18.287943,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "8.01123238px",
      fontFamily: "Arial",
      InkscapeFontSpecification: "'Arial, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.20028082
    }
  }, "the")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: "16.45045662px",
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.41126144
    },
    x: 12.408107,
    y: 18.181013,
    id: "text833-5"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan831-3",
    x: 12.408107,
    y: 18.181013,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "bold",
      fontStretch: "normal",
      fontSize: "16.4504528px",
      fontFamily: "Arial",
      InkscapeFontSpecification: "'Arial, Bold'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.41126144
    }
  }, "VAULT"))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.05f04a91.svg";
export { ForwardRef as ReactComponent };